import {
    put,
    call,
    select,
    takeEvery,
    takeLatest
} from 'redux-saga/effects';
import { Set as ISet } from 'immutable';

import { getPreferredCurrencyCode } from '../currency/currencyUtils';
import { getPreferredProgramCode } from '../program/programUtils';
import { getActiveProgramCode } from '../program/programSelectors';
import { SET_PROGRAM_CODE, clearProgram } from '../program/programModule';
import { SET_CART_STATUS, CART_STATUS } from '../cart/cartModule';
import { resetFieldValues } from '../item/newItemFormModule';
import {
    getRecipientName,
    getSenderName,
    getRecipientEmail,
    getAmount,
    getCardType,
    getFaceplateCode
} from '../app/postData';

import {
    getCartPath,
    getErrorNoRetryPath,
    getConfirmationPath,
    APP_ERROR_TYPES
} from './flow';
import {
    flowParamsUpdated,
    setPreferredCurrency,
    setPreferredProgram,
    removePreferredProgram,
    RESTART_BUY_FLOW,
    SHOW_APP_ERROR,
    ORDER_COMPLETE
} from './flowModule';
import { setPreferredValue, updateFlowProgress } from './flowProgressModule';
import { getHomePath } from './flowSelectors';
import {
    getURLSearchParams,
    push,
    removeQueryParams,
    replace,
    updateSearch
} from './routing';
import { LOCATION_CHANGE } from './routingModule';
import {
    AMOUNT_FIELD,
    RECIPIENT_NAME_FIELD,
    SENDER_NAME_FIELD,
    RECIPIENT_EMAIL_FIELD,
    IS_PLASTIC_FIELD,
    FACEPLATE_FIELD
} from '../item/newItemForm';
import {
    validateName,
    validateEmail,
    validateFaceplateCode, validateCardType
} from '../validate/postDataValidators';
import { formatAmountToString } from '../utils/numberUtils';
import { CARD_TYPE } from '../cardType/cardTypeModule';



export function* updateProgramCode({ programCode }) {
    const urlParams = yield call(getURLSearchParams);
    const urlProgramCode = yield call([urlParams, urlParams.get], 'programCode');
    if (programCode) {
        if (urlProgramCode !== programCode) {
            yield call(updateSearch, { programCode });
        }
    } else if (urlProgramCode !== null) {
        yield call(removeQueryParams, ['programCode']);
    }
    if (!programCode) {
        yield put(removePreferredProgram());
    }
}


export function* updateQueryParams() {
    
    
    
    
    const programCode = yield select(getActiveProgramCode);
    yield call(updateProgramCode, { programCode });
    yield put(flowParamsUpdated());
}


export function* updateCartStatus({ status }) {
    
    if (status === CART_STATUS.PROCESSING || status === CART_STATUS.READY) {
        yield call(push, ({ pathname: getCartPath() }));
    }
}


export function* restartBuyFlow() {
    const homePath = yield select(getHomePath);
    yield put(clearProgram());
    yield put(resetFieldValues());
    yield call(push, ({ pathname: homePath }));
}


export function* showAppError({ errorType }) {
    if (errorType === APP_ERROR_TYPES.NO_RETRY) {
        yield call(replace, { pathname: getErrorNoRetryPath() });
    }
}


export function* completeBuyFlow({ orderDetails }) {
    
    
    
    const location = {
        pathname: getConfirmationPath(),
        state: orderDetails
    };
    yield call(replace, location);
}


export function* initializeFlow() {
    
    

    const preferredCurrencyCode = yield call(getPreferredCurrencyCode);
    const preferredProgramCode = yield call(getPreferredProgramCode);
    if (preferredCurrencyCode) {
        yield put(setPreferredCurrency(preferredCurrencyCode));
        yield call(removeQueryParams, ['currencyCode', 'currency_code']);
    }
    yield put(setPreferredProgram(preferredProgramCode));
    const preferredRecipientName = validateName(yield call(getRecipientName));
    const preferredSenderName = validateName(yield call(getSenderName));
    const preferredRecipientEmail = validateEmail(yield call(getRecipientEmail));
    const preferredAmount = yield call(getAmount);
    const preferredCardType = validateCardType(yield call(getCardType));
    const preferredFaceplateCode = validateFaceplateCode(yield call(getFaceplateCode));
    if (preferredRecipientName) {
        yield put(setPreferredValue(RECIPIENT_NAME_FIELD, preferredRecipientName));
        yield put(updateFlowProgress(ISet([RECIPIENT_NAME_FIELD])));
    }
    if (preferredSenderName) {
        yield put(setPreferredValue(SENDER_NAME_FIELD, preferredSenderName));
        yield put(updateFlowProgress(ISet([SENDER_NAME_FIELD])));
    }
    if (preferredRecipientEmail) {
        yield put(setPreferredValue(RECIPIENT_EMAIL_FIELD, preferredRecipientEmail));
        yield put(updateFlowProgress(ISet([RECIPIENT_EMAIL_FIELD])));
    }
    if (preferredAmount) {
        yield put(setPreferredValue(AMOUNT_FIELD, formatAmountToString(preferredAmount)));
        yield put(updateFlowProgress(ISet([AMOUNT_FIELD])));
    }
    if (preferredCardType) {
        yield put(setPreferredValue(IS_PLASTIC_FIELD, (preferredCardType === CARD_TYPE.PHYSICAL)));
        yield put(updateFlowProgress(ISet([IS_PLASTIC_FIELD])));
    }
    
    if (preferredFaceplateCode && preferredCardType) {
        yield put(setPreferredValue(FACEPLATE_FIELD, preferredFaceplateCode));
        yield put(updateFlowProgress(ISet([FACEPLATE_FIELD])));
    }
}

export function* flowSagasWatcher() {
    yield takeEvery(LOCATION_CHANGE, updateQueryParams);
    yield takeEvery(SET_PROGRAM_CODE, updateProgramCode);
    yield takeLatest(SET_CART_STATUS, updateCartStatus);
    yield takeLatest(RESTART_BUY_FLOW, restartBuyFlow);
    yield takeLatest(ORDER_COMPLETE, completeBuyFlow);
    yield takeLatest(SHOW_APP_ERROR, showAppError);
}
